import { attribute, fillable, value } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default (scope = '[data-test-create-version]', properties = {}) => ({
  scope,
  name: value('input:first'),
  description: value('textarea'),
  fillInName: fillable('input:first'),
  fillInDescription: fillable('textarea'),
  submitButton: {
    scope: '.hds-button-set button[type="submit"]',
    isDisabled: attribute('disabled')
  },
  cancelButton: {
    scope: '.hds-button-set a.hds-button--color-secondary',
    href: attribute('href')
  },
  flash: {
    ...flashMessage,
    resetScope: true
  },
  ...properties
});